import instance from '@apis/instance';
import { EventResponse, EventRow } from '@models/event';
import { GetEventsParams } from '@models/event/request';
import { PageResponse } from '@models/page';

class EventApi {
  static getEvents(params: GetEventsParams): Promise<PageResponse<EventRow>> {
    return instance.get('/events', { params });
  }

  static getEvent(eventId: string): Promise<EventResponse> {
    return instance.get(`/events/${eventId}`);
  }
}

export default EventApi;
